import { render, staticRenderFns } from "./company.vue?vue&type=template&id=058b9878"
import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports